import { IValidation } from "@cak-legacy/generation-core";

export const convertCallbackToValidationArray = (
  validate: (() => IValidation[]) | IValidation[] | undefined
): IValidation[] | undefined => {
  if (!validate) {
    return undefined;
  }

  if (Array.isArray(validate)) {
    return validate;
  }

  return validate();
};
